import React, { ReactElement, useState } from 'react';
import { ApolloError } from '@apollo/client';
import { Modal } from '@odin-labs/components';
import { useArchiveWorkerMutation } from 'apollo/generated/client-operations';
import { AlertService } from 'components/alertService';
import { getGraphQLError } from 'utils/error';
import { ArchiveWorkerModalProps } from './types';

export function ArchiveWorkerModal({
  workerId,
  isOpen = false,
  closeModal,
  onConfirm,
}: ArchiveWorkerModalProps): ReactElement {
  const [fetching, setFetching] = useState<boolean>(false);
  const [archiveWorkerMutation] = useArchiveWorkerMutation({
    onCompleted: () => {
      setFetching(false);
      closeModal();
      onConfirm?.();
      AlertService.alert(
        'success',
        'Worker successfully archived',
        'This worker has been archived',
      );
    },
    onError: (archiveError: ApolloError) => {
      setFetching(false);
      AlertService.alert(
        'danger',
        'Something went wrong!',
        getGraphQLError(archiveError),
      );
    },
  });

  const archiveWorker = (): void => {
    if (fetching) {
      return;
    }
    setFetching(true);
    archiveWorkerMutation({
      variables: {
        workerId,
      },
    });
  };

  return (
    <Modal
      open={isOpen}
      setOpen={closeModal}
      onCancel={closeModal}
      onAction={archiveWorker}
      size="xs"
      cancelText="Cancel"
      actionText="Archive"
      title="Are you sure?"
      actionButtonEnabled={!fetching}
      actionButtonTheme="danger"
    >
      <div>
        <h3>Are you sure you want to archive this worker?</h3>
      </div>
    </Modal>
  );
}
